/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AdvertisementLoginSettings} from '../models/AdvertisementLoginSettings';
import type {Error} from '../models/Error';

export interface GetAdvertisementLoginSettings$Request {
    conferenceId: number;
}

export interface GetAdvertisementLoginSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAdvertisementLoginSettingsRequest = createAction<PayloadData<void, GetAdvertisementLoginSettings$Request>>('ADVERTISEMENT_LOGIN_SETTINGS__GET_ADVERTISEMENT_LOGIN_SETTINGS__REQUEST');
export const getAdvertisementLoginSettingsSuccess = createAction<PayloadData<AdvertisementLoginSettings, GetAdvertisementLoginSettings$Request>>('ADVERTISEMENT_LOGIN_SETTINGS__GET_ADVERTISEMENT_LOGIN_SETTINGS__SUCCESS');
export const getAdvertisementLoginSettingsFailure = createAction<PayloadData<Error, GetAdvertisementLoginSettings$Request, true>>('ADVERTISEMENT_LOGIN_SETTINGS__GET_ADVERTISEMENT_LOGIN_SETTINGS__FAILURE');

export const getAdvertisementLoginSettingsActions = [
    getAdvertisementLoginSettingsRequest,
    getAdvertisementLoginSettingsSuccess,
    getAdvertisementLoginSettingsFailure
] as const;

/**
 * @param {number} meta.conferenceId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAdvertisementLoginSettings = (meta: GetAdvertisementLoginSettings$Request, config?: GetAdvertisementLoginSettings$Config) => {
    return {
        CALL_API: {
            types: getAdvertisementLoginSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/conferences/${meta.conferenceId}/advertisements/login-settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateAdvertisementLoginSettings$Request {
    conferenceId: number;
    advertisementLoginSettings: AdvertisementLoginSettings;
}

export interface UpdateAdvertisementLoginSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateAdvertisementLoginSettingsRequest = createAction<PayloadData<void, UpdateAdvertisementLoginSettings$Request>>('ADVERTISEMENT_LOGIN_SETTINGS__UPDATE_ADVERTISEMENT_LOGIN_SETTINGS__REQUEST');
export const updateAdvertisementLoginSettingsSuccess = createAction<PayloadData<void, UpdateAdvertisementLoginSettings$Request>>('ADVERTISEMENT_LOGIN_SETTINGS__UPDATE_ADVERTISEMENT_LOGIN_SETTINGS__SUCCESS');
export const updateAdvertisementLoginSettingsFailure = createAction<PayloadData<Error, UpdateAdvertisementLoginSettings$Request, true>>('ADVERTISEMENT_LOGIN_SETTINGS__UPDATE_ADVERTISEMENT_LOGIN_SETTINGS__FAILURE');

export const updateAdvertisementLoginSettingsActions = [
    updateAdvertisementLoginSettingsRequest,
    updateAdvertisementLoginSettingsSuccess,
    updateAdvertisementLoginSettingsFailure
] as const;

/**
 * @param {number} meta.conferenceId
 * @param {AdvertisementLoginSettings} meta.advertisementLoginSettings
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateAdvertisementLoginSettings = (meta: UpdateAdvertisementLoginSettings$Request, config?: UpdateAdvertisementLoginSettings$Config) => {
    return {
        CALL_API: {
            types: updateAdvertisementLoginSettingsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/conferences/${meta.conferenceId}/advertisements/login-settings`,
            TRANSPORT_REQUEST_BODY: meta.advertisementLoginSettings,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

